import { defineRouting } from "next-intl/routing";
import { createNavigation } from "next-intl/navigation";

export const defaultLocale = "tr";
export const locales = ["en", "tr"] as const;
// Default language is Turkish for everyone. `localeDetection: false` disables
// automatic locale negotiation from the browser's `accept-language` header (the
// cause of users unintentionally landing on English). The manual choice still
// persists via the NEXT_LOCALE cookie (next-intl's `localeCookie`, on by
// default) — switching to English in the footer sticks across reloads/sessions.
export const routing = defineRouting({
  locales,
  defaultLocale,
  localeDetection: false,
});

export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);
